import axios from 'axios'

// 创建统一的axios实例 - 使用screenApi的配置
const api = axios.create({
  baseURL: 'https://wx.haikang.ltd/api',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 通用响应拦截器 - 处理未登录状态
const responseInterceptor = (response) => {
  const data = response.data

  // 检查是否未登录（仅 code 非 1 且 data 为 null 时视为未登录）
  if (data.data === null && Number(data.code) !== 1) {
    console.warn('检测到未登录状态，data为null')

    // 清除本地token
    localStorage.removeItem('token')

    // 如果在浏览器环境中，跳转到登录页
    if (typeof window !== 'undefined' && window.location) {
      // 避免重复跳转
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    }

    // 返回一个拒绝的Promise，阻止后续代码执行
    return Promise.reject(new Error('未登录或登录已过期'))
  }

  return data
}

// 通用请求拦截器 - 添加token
const requestInterceptor = (config) => {
  console.log('发送请求:', config.url)

  // 从localStorage获取token并添加到请求头
  const token = localStorage.getItem('token')
  if (token) {
    config.headers['token'] = `${token}`
  }

  return config
}

// 应用拦截器到api实例
api.interceptors.request.use(requestInterceptor, error => Promise.reject(error))
api.interceptors.response.use(responseInterceptor, error => {
  console.error('请求失败:', error.message)
  return Promise.reject(error)
})

// 导出实例和工具函数
export default api